import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDistance } from 'date-fns';
import { LocalStorageService } from 'src/core/services/local-storage.service';
import { MedicineService } from 'src/core/services/medicine.service';
import { Medicine } from 'src/interfaces/medicine';
import { format } from 'date-fns';

@Component({
    selector: 'core-medicine-list',
    templateUrl: './medicine-list.component.html',
    styleUrls: ['./medicine-list.component.scss'],
    standalone: false
})
export class MedicineListComponent implements OnInit {

  displayedColumns: string[] = [
    'name',
    'barcode_prefix',
    'active_ingredient',
    'schedule_status',
    'created',
    'updated'
    
  ];

  limit: number = 10;
  page: number = 1;
  sortDirection: string = 'asc';
  orderBy: string = 'name';
  totalNumberOfMedicine: number = 0;
  medicineDataSource: MatTableDataSource<Medicine>;
  medicineNameInput = this._formBuilder.control('');

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private _medicineService: MedicineService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _localStorageService: LocalStorageService,
    private _formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(): void {

    const limit = this._localStorageService.get('MEDICINE', 'LIMIT');

    if (limit) {
      this.limit = parseInt(limit);
    }

    this
      ._route
      .data
      .subscribe(data => {
        this.medicineDataSource = new MatTableDataSource<Medicine>(data.medicine.medicine);
        this.totalNumberOfMedicine = this._medicineService.getTotalNumberOfMedicine();
        this.medicineDataSource.sort = this.sort;
        this.page = data.medicine.pageNumber;
        // Initialize search from query params and fetch if present
        const qp = this._route.snapshot.queryParamMap;
        const qpSearch = qp.get('search');
        if (qpSearch) {
          this.medicineNameInput.setValue(qpSearch, { emitEvent: false });
          this.page = 1;
          this.listMedicine(
            this.page,
            this.limit,
            qpSearch,
            this.sortDirection,
            this.orderBy
          );
        }
      });

    this.medicineNameInput
      .valueChanges
      .subscribe(value => {
        this.page  = 1; // change page 
        this.listMedicine(
          this.page,
          this.limit,
          value,
          this.sortDirection,
          this.orderBy
        )
      });
  }

  onPageChange(event: PageEvent) {

    // Get more orders 
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;

    this._localStorageService.store('MEDICINE', 'LIMIT', this.limit.toString());
    this._localStorageService.store('MEDICINE', 'PAGE', this.page.toString());
    
    this.listMedicine(
      this.page,
      this.limit,
      this.medicineNameInput.value,
      this.sortDirection,
      this.orderBy
    );

  }

  listMedicine(page: number = 1, limit: number = 10, search: string | null = null,sortDirection:string,orderBy:string) {
    (async () => {
      const newMedicine = await this._medicineService.getMedicineList(page, limit, search,sortDirection,orderBy);
      const newData = [
        ...newMedicine
      ]
     

      this.medicineDataSource.data = newData;
      this.totalNumberOfMedicine = this._medicineService.getTotalNumberOfMedicine();
    })();
  }

  

  openMedicine(id: any) {
    this._router.navigate(["portal/medicine/view", id], {
      queryParams: {
        search: this.medicineNameInput.value || undefined,
      },
    });
  }

  formatTime(time: string | null): string {
    if (!time) return '-'
    return format(new Date(time), 'MMMM dd, yyyy HH:mm');
  }

  sortMedicine(sort:Sort){
    switch (sort.active) {
      case 'name':
        this.orderBy = 'name';
        this.sortDirection = sort.direction;
        break;
      default:
        this.orderBy = 'name';
        this.sortDirection = 'asc';
        break;
    }
    this.page = 1;
    this.listMedicine(
      this.page,
      this.limit,
      this.medicineNameInput.value,
      this.sortDirection,
      this.orderBy
    );
  }

  
}
